// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"159":"392baf89d9af41a9a032","339":"61bc003bb99be7809d82"}[chunkId] + ".js";
};